import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeaturedProductsModal } from './featured-products-modal/featured-products-modal';
import { Store } from '@ngrx/store';
import { setModels } from '../calculation/calculation.actions';
import { AppState } from '../app.state';
import { CalculationModelsState } from '../calculation/calculation.state';
import { ProgressSpinnerService } from '../components/progress-spinner/progress-spinner.service';
import { ProductsMetaService } from '../cart/products-meta.service';
import { FeaturedProductsService } from '../../api/services/featured-products.service';
import { FeaturedProductDto } from 'src/api/models/featured-product-dto';

@Component({
  selector: 'rc-landing-page',
  templateUrl: './featured-products.component.html',
  styleUrls: ['./featured-products.component.scss'],
})
export class FeaturedProductsComponent implements OnInit {
  products!: FeaturedProductDto[];
  getImagePath = ProductsMetaService.getImagePath;

  constructor(
    public featuredProductsService: FeaturedProductsService,
    public dialog: MatDialog,
    public progressSpinnerService: ProgressSpinnerService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.progressSpinnerService.openProgressSpinner();
    this.featuredProductsService.featuredProductsControllerGetFeaturedProducts().subscribe((response) => {
      this.products = response.results;
      if (this.products.length > 0) {
        this.progressSpinnerService.closeProgressSpinner();
      }
    });
  }

  openDialog(indexOfRoof: number) {
    const dialogRef = this.dialog.open(FeaturedProductsModal, {
      minWidth: '360px',
      width: '500px',
    });
    dialogRef.beforeClosed().subscribe(() => {
      const { roofProduct, roofFinish, roofThickness, roofColor } = this.products[indexOfRoof];
      const models: CalculationModelsState = {
        producer: roofProduct.producer,
        roof: roofProduct,
        finish: roofFinish,
        thickness: roofThickness,
        color: roofColor,
        hasDripStop: false,
      };
      this.store.dispatch(setModels({ models }));
    });
  }
}
